import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AxiosInstance } from 'axios';
import config from 'config';
import { useAxios } from 'context/AxiosContextProvider';

import useAccountDetailQuery from '../useAccountDetailQuery';

async function update(
  axios: AxiosInstance,
  account_id: number,
  status?: number,
  portal_id?: number,
  workshop_id?: number,
  username?: string,
  password?: string,
  random_password?: boolean,
  type?: string,
): Promise<object> {
  const { data } = await axios.put(`${config.apiBaseUrl}/op/v2/account/${account_id}`, {
    status: status,
    portal_id: portal_id,
    workshop_id: workshop_id,
    username: username,
    password: password,
    random_password: random_password,
    type: type,
  });
  return data.data;
}

export default function useUpdateAccountStatus(account_id: number) {
  const queryClient = useQueryClient();
  const axios = useAxios();
  return useMutation({
    mutationKey: ['UpdateAccountStatus', account_id],
    mutationFn: (params: {
      account_id: number;
      status?: number;
      portal_id?: number;
      workshop_id?: number;
      username?: string;
      password?: string;
      random_password?: boolean;
      type?: string;
    }) =>
      update(
        axios,
        params.account_id,
        params.status,
        params.portal_id,
        params.workshop_id,
        params.username,
        params.password,
        params.random_password,
        params.type,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: useAccountDetailQuery.getKey(account_id),
      });
    },
  });
}
